import React from 'react';
import { Page } from '../Page';
export function PageBrainSide() {
  return <Page pageNumber={4} variant="light" data-id="element-1266" data-mp="3qsjyru4y0ygp">
      <div className="flex flex-col h-full" data-id="element-1267" data-mp="3qr8w5xn8hwr6">
        <div className="mb-4 pt-4" data-id="element-1268" data-mp="3qud9bkiog2tz">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1269" data-mp="3vrdfrwjfv7lm">
            Understanding Your Medication
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1270" data-mp="4j98unbn3qnc">
            GLP-1 And <span className="text-tealslate" data-id="element-1271" data-mp="330v1dzd9ljsw">The Brain</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate mb-4" data-id="element-1272" data-mp="382u73fwh8st0" />
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1273" data-mp="3d1f5raw2z4fc">
            How the medication rewires your reward system and relationship with
            food.
          </p>
        </div>

        <p className="text-[10px] text-[#7A7A70] tracking-wider font-bold mb-1" data-id="element-1274" data-mp="2kcho99zp1bnn">
          <em data-id="element-1275" data-mp="2kadkqt5pienw">Figure 2</em>
        </p>
        <div className="flex-1 -mx-12 px-12 flex flex-col justify-center" data-id="element-1276" data-mp="2pb1a7aeaeng0">
          <div className="flex justify-center" data-id="element-1277" data-mp="29mesqi7zoa4x">
            <img src="https://cdn.magicpatterns.com/uploads/aL8CWLBGxDYU95eu597Ee5/Picture1.png" alt="Brain diagram showing how GLP-1 medication affects appetite centers, reward pathways, and the hypothalamus" className="h-[560px] object-contain" data-id="element-1278" data-mp="29l3fzswkfs1o" />
          </div>
        </div>

        <div className="pt-4" data-id="element-1279" data-mp="1uvfofje6s7r5">
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1280" data-mp="1qwgaxaee32o3">
            <strong className="text-[#1F1F1F]" data-id="element-1281" data-mp="1qtu5bgb26x8i">How it works:</strong>{' '}
            <em data-id="element-1282" data-mp="1lv92ra8c41gw">
              GLP-1 receptors in the brain's appetite and reward centers reduce
              food noise, dampen dopamine spikes from processed foods, and
              signal satisfaction. The result: fewer cravings and more control
              over what you eat.
            </em>
          </p>
        </div>
      </div>
    </Page>;
}